<template>
  <div style="height: 100%;">
    <div class="view-content">
      <div
        v-show="drawMode"
        ref="drawOverlayWrap"
        class="draw-overlay-wrap"
        :style="drawOverlayStyle">
        <draw-overlay-canvas
          ref="drawOverlay"
          :visible="drawMode"
          :width="drawOverlayCanvasWidth"
          :height="drawOverlayCanvasHeight"
          :rotation="drawRotation"
          :tool="drawTool"
          :stroke="drawStroke"
          :stroke-width="drawStrokeWidth"
          @history-change="onHistoryChange"/>
      </div>

      <draw-toolbar
        v-if="drawMode"
        :draw-saving="drawSaving"
        :draw-can-undo="drawCanUndo"
        :draw-can-redo="drawCanRedo"
        :stroke="drawStroke"
        @undo="onUndo"
        @redo="onRedo"
        @tool-change="setDrawTool"
        @rotate="onDrawRotate"
        @save="onDrawSave"
        @cancel="onDrawCancel"
        @stroke-change="onStrokeChange"/>
      <img v-if="preIndex !== null"
           style="display:none;"
           ref="image"
           :src="preSrc|ossHost(autoOrientSuffix)"
           @load="nextPreIndex">
      <ul style="display:none;"
          ref="images">
        <li v-for="({src}, index) in files"
            :key="index+src"><img :src="src|ossHost(suffix)"
                                  :alt="src.replace(/^.*\//, '').replace(/[?&#].*$/, '')">
        </li>
      </ul>
    </div>
    <div class="view-toolbar"
         v-if="!drawMode">
      <ul>
        <li
          class="draw-entry"
          :class="{ 'draw-disabled': !showDrawButton }"
          @click="enterDrawMode()">
          <span class="draw-entry-text">图片<br>标注</span>
        </li>
        <li v-show="lastToolbar.zoomIn"
            @click="onZoom(0.1)"><span class="sj-icon-enlarge"></span></li>

        <li v-show="lastToolbar.zoomOut"
            @click="onZoom(-0.1)"><span class="sj-icon-shrink"></span></li>

        <li v-show="lastToolbar.oneToOne"
            @click="onOneToOne()"><span class="sj-icon-one-to-one"></span></li>

        <li v-show="lastToolbar.prev"
            @click="onPrev()"><span class="el-icon-caret-left"></span></li>

        <li v-show="lastToolbar.next"
            @click="onNext()"><span class="el-icon-caret-right"></span></li>

        <li v-show="lastToolbar.reset"
            @click="onReset()"><span class="el-icon-refresh"></span></li>

        <li v-show="lastToolbar.rotateLeft"
            @click="onRotate(-90)"><span class="sj-icon-rotate-left"></span></li>

        <li v-show="lastToolbar.rotateRight"
            @click="onRotate(90)"><span class="sj-icon-rotate-right"></span></li>

        <!-- 工单证据图片放大页暂不展示标注按钮
        <li v-show="lastToolbar.label && loading"><span class="el-icon-loading"></span></li>
        <li v-show="lastToolbar.label && !loading"
            @click="onLabel()"><span class="sj-icon-shadow-box"></span></li>
        -->

        <li v-show="lastToolbar.delete"
            @click="onDelete()"><span class="el-icon-delete"></span></li>

        <li v-show="lastToolbar.download"
            @click="onDownload()"><span class="el-icon-download"></span></li>
      </ul>
    </div>
    <div class="view-toolbar-bottom"
         v-if="!drawMode">
      <ul>
        <li v-show="lastToolbar.zoomIn"
            @click="onZoom(0.1)"><span class="sj-icon-enlarge"></span></li>

        <li v-show="lastToolbar.zoomOut"
            @click="onZoom(-0.1)"><span class="sj-icon-shrink"></span></li>

        <li v-show="lastToolbar.oneToOne"
            @click="onOneToOne()"><span class="sj-icon-one-to-one"></span></li>

        <li v-show="lastToolbar.prev"
            @click="onPrev()"><span class="el-icon-caret-left"></span></li>

        <li v-show="lastToolbar.next"
            @click="onNext()"><span class="el-icon-caret-right"></span></li>

        <li v-show="lastToolbar.reset"
            @click="onReset()"><span class="el-icon-refresh"></span></li>

        <li v-show="lastToolbar.rotateLeft"
            @click="onRotate(-90)"><span class="sj-icon-rotate-left"></span></li>

        <li v-show="lastToolbar.rotateRight"
            @click="onRotate(90)"><span class="sj-icon-rotate-right"></span></li>

        <li v-show="lastToolbar.delete"
            @click="onDelete()"><span class="el-icon-delete"></span></li>

        <li v-show="lastToolbar.download"
            @click="onDownload()"><span class="el-icon-download"></span></li>
      </ul>
    </div>
    <div class="view-navbar">
      <ul class="clear-both"
          ref="view-list"
          :style="{width:`${ulWidth}px`, transform: `translateX(${ulTransform}px)`, pointerEvents: drawMode ? 'none' : 'auto'}">
        <li :class="viewIndex===index?'active':''"
            v-for="({src}, index) in files"
            :key="index+src"
            @click="view(index)">
          <img :src="src|ossHost(suffix)"
               :alt="src">
        </li>
      </ul>
    </div>
    <div class="view-footer-badge">
      <div>{{viewIndex + 1}}/{{files.length}}</div>
    </div>
  </div>
</template>

<script>
import fabric from '@/vendor/fabric'
import 'viewerjs/dist/viewer.css'
import Viewer from '@/vendor/viewerjs/viewer.esm.js'
import download from 'downloadjs'
import LableResult from '../../LableResult'
import DrawOverlayCanvas from './DrawOverlayCanvas.vue'
import DrawToolbar from './DrawToolbar.vue'

export default {
  mixins: [],
  components: {DrawOverlayCanvas, DrawToolbar},
  props: {
    files: {
      type: Array,
      default: () => {
        return []
      },
    },
    index: {
      type: Number,
      default: 0,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    toolbar: {
      type: Object,
      default: {},
    },
    getLableData: Function,
    orderId: {
      type: [Number, String],
      default: null,
    },
  },
  data () {
    return {
      viewer: null,
      loading: false,
      lableData: {},
      visibleLabel: false,
      imgrHost: window._env_.VUE_APP_IMGR_HOST,
      viewIndex: 0,
      preIndex: -1,
      preFiles: [],
      liWidth: 60,
      ulTransform: 0,
      suffix: '?x-oss-process=image/resize,m_pad,h_55,w_55,color_FFFFFF',
      // 此处无法使用 auto-orient，因极高品质会超过4096
      autoOrientSuffix: '?x-oss-process=image/resize,l_4096',

      drawMode: false,
      drawTool: 'select',
      drawStroke: '#ff0000',
      drawStrokeWidth: 3,
      drawSaving: false,
      drawCanUndo: false,
      drawCanRedo: false,
      drawOverlayStyle: {},
      drawOverlayCanvasWidth: 0,
      drawOverlayCanvasHeight: 0,
      drawRotation: 0,
    }
  },
  computed: {
    ulWidth () {
      return this.liWidth * this.files.length
    },
    src () {
      return this.files[this.viewIndex].src
    },
    preSrc () {
      if (this.preIndex !== -1) {
        return this.preFiles[this.preIndex].src
      }
      return ''
    },
    lastToolbar () {
      return {
        zoomIn: true,
        zoomOut: true,
        oneToOne: true,
        reset: true,
        prev: true,
        next: true,
        rotateLeft: true,
        rotateRight: true,
        label: false,
        delete: false,
        download: true,
        ...this.toolbar,
      }
    },
    showDrawButton () {
      return !!this.orderId
    },
  },
  watch: {
    visible (val) {
      if (val) {
        // 显示当前图片
        this.view(this.index)
      } else {
        this.exitDrawMode(true)
        // 关闭预加载
        this.preIndex = -1
        this.preFiles = []
        // 销毁查看器
        this.viewer.destroy()
        this.viewer = null
      }
      this.listenerKeyboard()
    },
  },
  created () {
    this.view(this.index)
    this.listenerKeyboard()
    this.$nextTick(() => {})
  },
  mounted () {},
  destroyed () {
    if (this.drawSaving) {
      this.setDrawSaving(false)
    }
  },
  methods: {
    initViewer (initialViewIndex) {
      this.viewer = new Viewer(this.$refs.images, {
        initialViewIndex,
        inline: true,
        button: false,
        navbar: false,
        title: false,
        // backdrop: false,
        toolbar: false,
        url: (image) => {
          return filter.ossHost(image.src.replace(this.suffix, ''), this.autoOrientSuffix)
        },
        ready: () => {
          // 预加载下一张图片
          this.nextPreIndex()
        },
        view: () => {
          this.$emit('label')
        },
        viewed: () => {
          this.$nextTick(this.onLabel)
        },
      })
    },

    setDrawTool (tool) {
      this.drawTool = tool
    },

    setDrawSaving (saving) {
      saving = !!saving
      this.drawSaving = saving
      this.$emit('draw-saving-change', saving)
    },

    onHistoryChange ({canUndo, canRedo} = {}) {
      this.drawCanUndo = !!canUndo
      this.drawCanRedo = !!canRedo
    },

    onUndo () {
      if (!this.drawMode) return
      if (!this.$refs.drawOverlay || !this.$refs.drawOverlay.undo) return
      this.$refs.drawOverlay.undo()
    },

    onRedo () {
      if (!this.drawMode) return
      if (!this.$refs.drawOverlay || !this.$refs.drawOverlay.redo) return
      this.$refs.drawOverlay.redo()
    },

    onDrawRotate (degree) {
      if (!this.drawMode || !this.viewer) return
      this.viewer.rotate(degree)
      // 旋转后适配可见区域；标注层只改 CSS（旋转+外框尺寸），不重绘 fabric 对象
      this.fitDrawImageInView()
      this.syncDrawOverlayToViewer()
      this.$nextTick(() => {
        if (this.$refs.drawOverlay && this.$refs.drawOverlay.canvas && this.$refs.drawOverlay.canvas.calcOffset) {
          this.$refs.drawOverlay.canvas.calcOffset()
        }
      })
    },

    /**
     * 按当前旋转角度，把图片（含 CSS 旋转后的可视宽高）完整适配进 viewer 可见区域
     * 预留 2px 并向下取整，避免旋转后 AABB 因亚像素/取整超出 viewer-canvas 被裁边
     */
    fitDrawImageInView () {
      if (!this.viewer || !this.viewer.imageData || !this.viewer.viewerData) return
      const imageData = this.viewer.imageData
      const viewerData = this.viewer.viewerData
      const naturalWidth = imageData.naturalWidth
      const naturalHeight = imageData.naturalHeight
      if (!naturalWidth || !naturalHeight) return

      const rotate = this.normalizeDrawRotation(imageData.rotate)
      const isQuarterTurn = rotate === 90 || rotate === 270
      // 90/270 时可视宽高对调
      const visualNaturalWidth = isQuarterTurn ? naturalHeight : naturalWidth
      const visualNaturalHeight = isQuarterTurn ? naturalWidth : naturalHeight
      // 与 viewer-canvas overflow:hidden 对齐：略缩小可用区，杜绝贴边被裁 1px
      const fitPad = 2
      const availWidth = Math.max(viewerData.width - fitPad, 1)
      const availHeight = Math.max(viewerData.height - fitPad, 1)
      const fitRatio = Math.min(
        availWidth / visualNaturalWidth,
        availHeight / visualNaturalHeight
      )
      if (!fitRatio || !isFinite(fitRatio)) return

      // layout 尺寸仍按未旋转坐标系，显示靠 CSS rotate；floor 保证旋转后可视边不超过 avail*
      const newWidth = Math.floor(naturalWidth * fitRatio)
      const newHeight = Math.floor(naturalHeight * fitRatio)
      if (!newWidth || !newHeight) return
      imageData.width = newWidth
      imageData.height = newHeight
      imageData.ratio = newWidth / naturalWidth
      imageData.left = (viewerData.width - newWidth) / 2
      imageData.top = (viewerData.height - newHeight) / 2

      if (typeof this.viewer.renderImage === 'function') {
        this.viewer.renderImage()
      }
    },

    normalizeDrawRotation (degree) {
      return ((degree % 360) + 360) % 360
    },

    getBackgroundSrcForExport () {
      const file = this.files[this.viewIndex] || {}
      const src = file.src || ''
      if (!src) return ''
      const normalizedSrc = this.suffix && src.includes(this.suffix) ? src.replace(this.suffix, '') : src
      return filter.ossHost(normalizedSrc, this.autoOrientSuffix)
    },

    /** 协议相对地址（//xxx）在部分环境下 fetch/axios 表现不稳定，统一为绝对地址 */
    resolveAbsoluteMediaUrl (url) {
      if (!url) return ''
      if (url.indexOf('//') === 0) {
        return window.location.protocol + url
      }
      return url
    },

    /**
     * 拉取 OSS 图片二进制。浏览器直连 OSS 受 CORS 限制时无法读响应体；
     * 优先走后端同源代理（与财务 getFinCenterFileUrlForDownload 同路径），由服务端代拉 OSS。
     */
    async fetchRemoteImageBlob (url) {
      const absoluteUrl = this.resolveAbsoluteMediaUrl(url)
      const proxyBases = [
        window._env_.VUE_APP_FIN_CENTER_HOST,
        window._env_.VUE_APP_ADMIN_HOST,
      ].filter(Boolean)
      for (let i = 0; i < proxyBases.length; i++) {
        const proxyUrl = `${proxyBases[i]}/oss_file_download?name=file&type=pic&url=${encodeURIComponent(absoluteUrl)}`
        try {
          const { data } = await axios.get(proxyUrl, {
            responseType: 'blob',
            timeout: 120000,
            maxContentLength: Infinity,
            maxBodyLength: Infinity,
          })
          return data
        } catch (e) {
          // 换下一档代理或回退直连 OSS
        }
      }
      const http = axios.create()
      try {
        const { data } = await http.get(absoluteUrl, {
          responseType: 'blob',
          timeout: 120000,
          maxContentLength: Infinity,
          maxBodyLength: Infinity,
        })
        return data
      } catch (e) {
        const res = await fetch(absoluteUrl, {
          credentials: 'omit',
          mode: 'cors',
        })
        if (!res.ok) {
          throw e
        }
        return res.blob()
      }
    },

    syncDrawOverlayToViewer () {
      if (!this.viewer || !this.viewer.imageData) return
      const imageData = this.viewer.imageData
      const rotate = Number(imageData.rotate) || 0
      this.drawRotation = this.normalizeDrawRotation(rotate)
      const nextWidth = Math.round(imageData.width || 0)
      const nextHeight = Math.round(imageData.height || 0)

      // fabric 内部坐标系只在进入标注时初始化一次；之后只同步外层 CSS
      // 这样旋转时整块 canvas（含已画的框）直接 CSS rotate，无对象重绘延迟
      if (!this.drawOverlayCanvasWidth || !this.drawOverlayCanvasHeight) {
        this.drawOverlayCanvasWidth = nextWidth
        this.drawOverlayCanvasHeight = nextHeight
      }

      this.drawOverlayStyle = {
        position: 'absolute',
        left: `${Math.round(imageData.left || 0)}px`,
        top: `${Math.round(imageData.top || 0)}px`,
        width: `${nextWidth}px`,
        height: `${nextHeight}px`,
        transform: rotate ? `rotate(${rotate}deg)` : 'none',
        transformOrigin: 'center center',
        pointerEvents: 'auto',
      }
    },

    enterDrawMode () {
      if (this.drawMode) return
      if (!this.showDrawButton) {
        this.$message.warning('当前为只读模式，不可操作')
        return
      }
      this.drawMode = true
      this.drawTool = 'rect'
      this.drawSaving = false
      this.drawCanUndo = false
      this.drawCanRedo = false
      this.drawRotation = 0
      // 清空以便重新锁定本次标注的 fabric 尺寸
      this.drawOverlayCanvasWidth = 0
      this.drawOverlayCanvasHeight = 0
      this.drawOverlayStyle = {}

      if (this.viewer && this.viewer.canvas) {
        this.viewer.canvas.style.pointerEvents = 'none'
      }
      if (this.viewer && this.viewer.viewer) {
        this.viewer.viewer.style.pointerEvents = 'none'
      }

      if (this.viewer && this.viewer.reset) {
        this.viewer.reset()
      }

      this.$nextTick(() => {
        // 先清空旧标注，再锁定新尺寸，避免旧对象被短暂拉伸
        if (this.$refs.drawOverlay && this.$refs.drawOverlay.reset) {
          this.$refs.drawOverlay.reset()
        }
        this.syncDrawOverlayToViewer()
        this.$nextTick(() => {
          if (this.$refs.drawOverlay && this.$refs.drawOverlay.canvas && this.$refs.drawOverlay.canvas.calcOffset) {
            this.$refs.drawOverlay.canvas.calcOffset()
          }
        })
      })
    },

    async onDrawSave () {
      if (!this.drawMode || this.drawSaving) return
      if (!this.$refs.drawOverlay) return

      const hasDrawn = this.$refs.drawOverlay.hasDrawn && this.$refs.drawOverlay.hasDrawn()
      const hasRotation = this.normalizeDrawRotation(this.drawRotation) !== 0
      // 画了标注，或仅旋转，都应保存生效
      if (!hasDrawn && !hasRotation) {
        this.exitDrawMode(true)
        return
      }

      const confirmText = hasDrawn
        ? '已记录退回标记内容，请确认保存？'
        : '已记录旋转后的图片内容，请确认保存更新？'
      this.$confirm(confirmText, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        try {
          this.setDrawSaving(true)
          const backgroundSrc = this.getBackgroundSrcForExport()
          if (!backgroundSrc) {
            throw new Error('导出数据缺失')
          }

          const imageData = (this.viewer && this.viewer.imageData) || {}
          const naturalWidth = imageData.naturalWidth
          const naturalHeight = imageData.naturalHeight
          if (!naturalWidth || !naturalHeight) {
            throw new Error('获取图片尺寸失败')
          }

          // 1) 加载背景图（从 OSS 获取为 blob，避免跨域 taint；需桶已配置 CORS）
          const backgroundBlob = await this.fetchRemoteImageBlob(backgroundSrc)
          const backgroundUrl = URL.createObjectURL(backgroundBlob)
          const backgroundImg = await new Promise((resolve, reject) => {
            const img = new Image()
            img.onload = () => resolve(img)
            img.onerror = (e) => reject(e)
            img.src = backgroundUrl
          })

          // 2) 如有标注再加载 overlay；仅旋转时跳过
          let overlayImg = null
          if (hasDrawn) {
            const overlayDataUrl = await this.$refs.drawOverlay.getOverlayDataUrl()
            if (!overlayDataUrl) {
              throw new Error('导出数据缺失')
            }
            overlayImg = await new Promise((resolve, reject) => {
              const img = new Image()
              img.onload = () => resolve(img)
              img.onerror = (e) => reject(e)
              img.src = overlayDataUrl
            })
          }

          const rotation = this.normalizeDrawRotation(this.drawRotation)
          const isQuarterTurn = rotation === 90 || rotation === 270
          const outputWidth = isQuarterTurn ? naturalHeight : naturalWidth
          const outputHeight = isQuarterTurn ? naturalWidth : naturalHeight
          const canvas = document.createElement('canvas')
          canvas.width = outputWidth
          canvas.height = outputHeight
          const ctx = canvas.getContext('2d')
          ctx.save()
          if (rotation === 90) {
            ctx.translate(outputWidth, 0)
            ctx.rotate(Math.PI / 2)
          } else if (rotation === 180) {
            ctx.translate(outputWidth, outputHeight)
            ctx.rotate(Math.PI)
          } else if (rotation === 270) {
            ctx.translate(0, outputHeight)
            ctx.rotate(Math.PI * 1.5)
          }
          // 背景与标注处于同一未旋转坐标系，一起旋转后合成
          ctx.drawImage(backgroundImg, 0, 0, naturalWidth, naturalHeight)
          if (overlayImg) {
            ctx.drawImage(overlayImg, 0, 0, naturalWidth, naturalHeight)
          }
          ctx.restore()

          const blob = await new Promise((resolve) => {
            canvas.toBlob(b => resolve(b), 'image/jpeg', 0.92)
          })

          URL.revokeObjectURL(backgroundUrl)

          if (!blob) {
            throw new Error('图片合成失败')
          }

          const ext = blob.type ? blob.type.split('/').pop() : 'jpg'
          const url = this.src + '.annotation.' + ext
          const res = await request.common('uploadOrderReviewDirectFile', {
            ext,
            content_type: blob.type || 'image/jpeg',
            url,
          })

          const uploadUrl = res.data.signedUrl
          const contentType = res.data.content_type
          await fetch(uploadUrl, {
            method: 'PUT',
            headers: new Headers({
              'Content-Type': contentType,
            }),
            body: blob,
          })

          const fileUrl = res.data.url
          const file = this.files[this.viewIndex]
          file.src = fileUrl
          this.$emit('draw-saved', {
            src: fileUrl,
            index: this.viewIndex,
          })
          // 等一次 $nextTick() 再解锁，避免外部审核结果还没同步就被关掉
          await this.$nextTick()
          this.refreshCurrentViewerImage()
          this.$message.success('标注图片已保存')
          this.exitDrawMode(true)
        } catch (e) {
          this.$message.error('保存失败')
        } finally {
          this.setDrawSaving(false)
        }
      }).catch(() => {})
    },

    onDrawCancel () {
      if (!this.drawMode) return
      this.$confirm('退出画图并丢弃本次绘制吗？', '提示', {
        confirmButtonText: '丢弃',
        cancelButtonText: '继续画',
        type: 'warning',
      }).then(() => {
        this.exitDrawMode(true)
      }).catch(() => {})
    },

    onStrokeChange (val) {
      if (!this.drawMode) return
      this.drawStroke = val
    },

    refreshCurrentViewerImage () {
      this.$nextTick(() => {
        if (!this.viewer) return
        if (this.viewer.update) {
          this.viewer.update()
        }
        if (this.viewer.view) {
          this.viewer.view(this.viewIndex)
        }
      })
    },

    exitDrawMode (restoreViewer) {
      if (!this.drawMode) return
      this.drawMode = false
      this.drawTool = 'select'
      this.drawRotation = 0
      this.drawOverlayCanvasWidth = 0
      this.drawOverlayCanvasHeight = 0
      this.drawOverlayStyle = {}
      if (restoreViewer && this.viewer && this.viewer.canvas) {
        this.viewer.canvas.style.pointerEvents = ''
      }
      if (restoreViewer && this.viewer && this.viewer.viewer) {
        this.viewer.viewer.style.pointerEvents = ''
      }
      if (this.$refs.drawOverlay && this.$refs.drawOverlay.discardChanges) {
        this.$refs.drawOverlay.discardChanges()
      }
    },
    nextPreIndex () {
      // 仅显示时预加载图片
      if (this.visible) {
        // 预设初始值
        if (this.preIndex === -1) {
          // 生成预加载文件列表
          this.preFiles = [
            ...this.files.slice(this.index),
            ...this.files.slice(0, this.index),
          ]
          this.preIndex = 0
          return
        }
        // 递增
        if (this.preIndex < this.preFiles.length - 1) {
          this.preIndex++
        }
      }
    },
    listenerKeyboard () {
      if (this.visible) {
        document.addEventListener('keydown', this.keyboard)
      } else {
        document.removeEventListener('keydown', this.keyboard)
      }
    },
    keyboard (e) {
      const code = e.keyCode || e.which || e.charCode
      if (this.drawMode) {
        const isCtrl = e.ctrlKey || e.metaKey
        const overlay = this.$refs.drawOverlay

        // 输入文字时，只处理撤销/重做等快捷键
        if (overlay && overlay.isTextEditing && overlay.isTextEditing() && !isCtrl) return

        // Ctrl/Cmd + Z => Undo；Ctrl/Cmd + Shift + Z 或 Ctrl/Cmd + Y => Redo
        if (isCtrl && (code === 90 || e.key === 'z' || e.key === 'Z')) {
          if (e.shiftKey) {
            this.onRedo()
          } else {
            this.onUndo()
          }
          e.preventDefault()
          return
        }
        if (isCtrl && (code === 89 || e.key === 'y' || e.key === 'Y')) {
          this.onRedo()
          e.preventDefault()
          return
        }

        // 工具切换快捷键（不显示“拖动”，但保留选择态 via ESC/V）
        // 1: 矩形；2: 椭圆/圆形（按住 Shift 画圆）；3: 自由绘画；4: 文字
        if (!e.altKey && !isCtrl) {
          switch (code) {
            case 27: // ESC
              this.setDrawTool('select')
              break
            case 49: // 1
              this.setDrawTool('rect')
              break
            case 50: // 2
              this.setDrawTool('ellipse')
              break
            case 51: // 3
              this.setDrawTool('free')
              break
            case 52: // 4
              this.setDrawTool('text')
              break
            case 53: // 5
              this.setDrawTool('arrow')
              break
            case 86: // V
              this.setDrawTool('select')
              break
            case 87: // W
              this.onDrawRotate(-90)
              break
            case 83: // S
              this.onDrawRotate(90)
              break
          }
        }
        return
      }

      switch (code) {
        // A
        case 65:
          this.onPrev()
          break
        // D
        case 68:
          this.onNext()
          break
        // W
        case 87:
          this.onRotate(-90)
          break
        // S
        case 83:
          this.onRotate(90)
          break
      }
    },
    view (index) {
      if (LableResult.isInstance()) {
        LableResult.destroy()
        this.lableInit = null
        this.visibleLabel = false
        this.loading = false
      }
      if (index < 0) {
        index = 0
      }
      if (index >= this.files.length) {
        index = this.files.length - 1
      }
      this.viewIndex = index
      this.$emit('changeIndex', index)
      this.$nextTick(() => {
        this.transform()
        if (this.viewer) {
          this.viewer.update()
          this.viewer.view(index)
        } else {
          this.initViewer(index)
        }
      })
    },
    transform () {
      this.ulTransform = (this.$el.offsetWidth - this.liWidth) / 2 - this.liWidth * this.viewIndex
    },
    onZoom (ratio) {
      this.viewer.zoom(ratio)
    },
    onOneToOne () {
      this.viewer.toggle()
    },
    onPrev () {
      this.view(this.viewIndex - 1)
    },
    onNext () {
      this.view(this.viewIndex + 1)
    },
    onReset () {
      this.viewer.reset()
    },
    onRotate (degree) {
      if (this.drawMode) {
        this.onDrawRotate(degree)
        return
      }
      this.viewer.rotate(degree)
    },
    onDelete () {
      let {files, viewIndex} = this
      if (files.length > 1) {
        files.splice(viewIndex, 1)
        this.view(viewIndex)
      }
    },
    onDownload () {
      let {src} = this.files[this.viewIndex]
      // 替换掉 http, 防止出现 https 向 http 请求的错误
      download(filter.ossHost(src))
    },
    getTransform (targetNode) {
      let transform = $(targetNode).css('transform')
      let left = parseFloat($(targetNode).css('margin-left'))
      let top = parseFloat($(targetNode).css('margin-top'))
      let matrix = [1, 0, 0, 1, 0, 0]
      if (transform !== 'none') {
        matrix = transform.slice(7, transform.length - 1).split(', ')
      }
      if (targetNode.naturalWidth !== targetNode.width || targetNode.naturalHeight !== targetNode.height) {
        matrix = fabric.util.multiplyTransformMatrices(matrix, [targetNode.width / targetNode.naturalWidth, 0, 0, targetNode.height / targetNode.naturalHeight, 0, 0], false)
        left -= (targetNode.naturalWidth - targetNode.width) / 2
        top -= (targetNode.naturalHeight - targetNode.height) / 2
      }
      return {left, top, matrix}
    },
    loadLableResult (src) {
      let container = $('.view-content .viewer-canvas')[0]
      let img = $('img', container)[0]

      let init = () => {
        let {left, top, matrix} = this.getTransform(img)
        LableResult(container).init(this.lableData[src], left, top, matrix).show()
      }

      let mutationObserver = () => {
        // Select the node that will be observed for mutations
        let targetNode = img

        // Options for the observer (which mutations to observe)
        let config = {
          attributes: true,
          // childList: true,
          // subtree: true
        }

        let changeCount = 0
        let lastCSSText = img.style.cssText
        // Callback function to execute when mutations are observed
        const mutationCallback = (mutationsList) => {
          if (lastCSSText === img.style.cssText) {
            return false
          }
          changeCount++
          LableResult.hide()
          lastCSSText = img.style.cssText
          // 记录本次缓存的数据已变化次数
          let updateCount = changeCount
          // 延迟300毫秒保存数据
          setTimeout(() => {
            // 数据还处于变化中，等待变化完毕后执行缓存
            if (updateCount === changeCount) {
              let {left, top, matrix} = this.getTransform(img)
              LableResult(container).update(left, top, matrix).show()
            }
          }, 400)
        }

        // Create an observer instance linked to the callback function
        this.observer = new MutationObserver(mutationCallback)

        // Start observing the target node for configured mutations
        this.observer.observe(targetNode, config)
      }

      this.visibleLabel = !this.visibleLabel
      if (this.visibleLabel) {
        if (this.lableInit) {
          let {left, top, matrix} = this.getTransform(img)
          LableResult(container).update(left, top, matrix).show()
          mutationObserver()
        } else {
          init()
          mutationObserver()
          this.lableInit = true
        }
      } else {
        LableResult.hide()
        // Later, you can stop observing
        this.observer.disconnect()
      }
    },
    onLabel () {
      if (this.lastToolbar.label && this.getLableData) {
        let {src} = this.files[this.viewIndex]

        if (this.lableData.hasOwnProperty(src)) {
          this.loadLableResult(src)
          this.$emit('labeled')
        } else {
          this.loading = true
          this.getLableData(src).then(({data}) => {
            if (data) {
              this.lableData[src] = data
              this.onLabel()
            }
          }).finally(() => {
            this.loading = false
          })
        }
      }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss"
       scoped>
.view-content {
  /* 与 ViewVideo 一致：为底部缩略图栏留空，并裁掉旋转后溢出 */
  height: calc(100% - 57px);
  overflow: hidden;
  position: relative;
}

.view-toolbar {
  left: 16px;
  bottom: 76px;
  max-height: calc(100% - 146px);
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  position: absolute;
  top: 70px;
  text-align: left;
  z-index: 40;

  ul {
    display: block;
    list-style: none;
    margin: 0;
    overflow: visible;
    padding: 0;

    li {
      &:hover {
        background-color: rgba(0, 0, 0, 0.8);
      }

      [class*=" el-icon-"],
      [class^="el-icon-"],
      [class*=" sj-icon-"],
      [class^="sj-icon-"] {
        color: rgba(255, 255, 255, 0.7);
        font-size: 24px;
        line-height: 48px;
      }

      .draw-entry-text {
        color: #409EFF;
        display: block;
        font-size: 13px;
        font-weight: bold;
        line-height: 16px;
      }

      &.draw-entry {
        background-color: #ecf5ff;
        border: 1px solid #b3d8ff;
        border-radius: 8px;
        box-sizing: border-box;
        height: auto;
        min-height: 48px;
        padding: 6px 4px;
        width: 48px;

        &:hover {
          background-color: #d9ecff;
          border-color: #409EFF;
        }
      }

      margin: 0 0 8px;
      background-color: rgba(0, 0, 0, 0.5);
      border-radius: 50%;
      cursor: pointer;
      display: block;
      height: 48px;
      overflow: hidden;
      transition: background-color 0.15s;
      text-align: center;
      width: 48px;
    }
  }
}

.view-toolbar-bottom {
  bottom: 57px;
  left: 0;
  overflow: hidden;
  position: absolute;
  right: 0;
  text-align: center;
  height: 36px;
  z-index: 40;

  ul {
    display: inline-block;
    margin: 0 auto 5px;
    overflow: hidden;
    padding: 3px 0;

    li {
      &:hover {
        background-color: rgba(0, 0, 0, 0.8);
      }

      [class*=" el-icon-"],
      [class^="el-icon-"],
      [class*=" sj-icon-"],
      [class^="sj-icon-"] {
        color: rgba(255, 255, 255, 0.7);
        line-height: 24px;
      }

      margin: 0px 1px;
      background-color: rgba(0, 0, 0, 0.5);
      border-radius: 50%;
      cursor: pointer;
      float: left;
      height: 24px;
      overflow: hidden;
      transition: background-color 0.15s;
      width: 24px;
    }
  }
}

.draw-disabled {
  cursor: not-allowed !important;
  opacity: 0.5;
}

.draw-overlay-wrap {
  z-index: 20;
  /* 裁掉画到 wrap 外的标注；旋转后也不应冒出到缩略图区 */
  overflow: hidden;

  // fabric 内部坐标系固定，外层用 CSS 缩放/旋转；容器与 canvas 铺满 wrap
  /deep/ .canvas-container {
    width: 100% !important;
    height: 100% !important;
  }

  /deep/ .canvas-container canvas {
    width: 100% !important;
    height: 100% !important;
  }
}

.draw-toolbar {
  bottom: 57px;
  left: 0;
  right: 0;
  position: absolute;
  overflow: hidden;
  text-align: center;
  z-index: 30;
  pointer-events: auto;

  ul {
    list-style: none;
    padding: 0;
    margin: 0 auto;
    display: inline-block;
    background-color: rgba(0, 0, 0, 0.55);
    border-radius: 6px;
  }

  li {
    display: inline-block;
    padding: 0 6px;
  }

  .draw-toolbar-actions {
    padding-left: 10px;
  }

  .el-button {
    color: rgba(255, 255, 255, 0.75);
  }

  .paint-icon {
    width: 14px;
    height: 14px;
    vertical-align: middle;
    color: currentColor;
  }

  .paint-icon path,
  .paint-icon rect,
  .paint-icon ellipse {
    fill: none;
    stroke: currentColor;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  .el-button.is-disabled .paint-icon {
    opacity: 0.35;
  }
}

.view-navbar {
  position: absolute;
  right: 0px;
  bottom: 0px;
  width: 100%;
  background-color: rgba(0, 0, 0, .95);
  overflow: hidden;
  /* 高于标注层，旋转溢出时也不要盖住缩略图 */
  z-index: 25;

  ul {
    transform: translateX(0px);
    margin: 10px 0px;
    transition: all 0.3s;
    box-sizing: content-box;
    height: 55px;
    margin: 0;
    overflow: hidden;
    padding: 1px 0;

    li {
      &.active {
        opacity: 1;
      }

      float: left;
      list-style: none;
      width: 55px;
      height: 55px;
      margin-right: 5px;
      background-color: #fff;
      color: transparent;
      cursor: pointer;
      float: left;
      font-size: 0;
      line-height: 0;
      opacity: 0.5;
      overflow: hidden;
      transition: opacity 0.15s;
    }
  }
}

.view-footer-badge {
  display: flex;
  justify-content: center;
  right: 0px;
  bottom: 60px;
  height: 75px;
  width: 100px;
  position: absolute;
  border-radius: 50% 0 0 50%;
  background: rgba(144, 147, 153, 0.3);
  font-size: 30px;

  div {
    line-height: 75px;
    color: #fff;
  }
}
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/question-review/components/AnswerFileFullScreen/src/ViewImage.vue